import { Entity, Input, Var } from "addeus-common-library/stores/firestore";
import moment from "moment-with-locales-es6";
import { Owner } from "./owner";
import { EntityArray } from "addeus-common-library/stores/firestore/entity";

export enum ClosureType {
    closure = "closure",
    opening = "opening",
}

export enum WeekDays {
    sunday,
    monday,
    tuesday,
    wednesday,
    thursday,
    friday,
    saturday,
}

export class Closure extends Entity {
    static collectionName = "closureDates";

    @Var(ClosureType)
    @Input("select", { required: true, options: ClosureType })
    type: ClosureType = ClosureType.closure;

    @Var(moment)
    @Input("date", { required: true })
    startDate: moment = moment().startOf("day");

    @Var(moment)
    @Input("date", { required: true })
    endDate: moment = moment().add(1, "day").startOf("day");

    @Var(Array.of(Number))
    @Input("select", {
        multiple: true,
        required: true,
        options: WeekDays,
    })
    daysOfWeek: WeekDays[] = EntityArray([1, 2, 3, 4, 5, 6, 0]);

    @Var(String)
    @Input("text")
    startTime: string = "00:00";

    @Var(String)
    @Input("text")
    endTime: string = "23:59";

    @Var(String)
    @Input("text", { required: true })
    comment?: string;

    @Var(Owner)
    owner?: Owner;
}
